import React from 'react';

export const UserAccountIcon = ({ width = '16px', height = '18px', fill = 'currentColor', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 472.615 472.615"
    width={width}
    height={height}
    fill={fill}
    {...props}
  >
    <circle cx="236.308" cy="117.504" r="111.537" />
    <path d="M369 246.306c-1.759-1.195-5.297-3.493-5.297-3.493-28.511 39.583-74.993 65.402-127.395 65.402-52.407 0-98.894-25.825-127.404-65.416 0 0-2.974 1.947-4.451 2.942C41.444 288.182 0 360.187 0 441.87v24.779h472.615V441.87c0-81.321-41.077-153.048-103.615-195.564z" />
  </svg>
);
